import type { PanelType } from '../../../../types/LayoutConfig';

/**
 * Panel types with a mobile component in `MobileTradingPanelDispatcher`. Shared with `useMobileTradingNavItems`
 * so unsupported blotters (commented out below) are hidden from the TabBar/overflow menu instead of only
 * being caught after navigation.
 */
export const MOBILE_SUPPORTED_PANEL_TYPES: readonly PanelType[] = [
  'marketCards',
  'predictionMarkets',
  'watchlist',
  'ordersBlotter',
  'tradesBlotter',
  'positionsBlotter',
  'balancesBlotter',
  'creditBlotter',
  // 'otcDerivatives',
  // 'loans',
  'transfersBlotter',
  // 'reconMismatches',
  // 'hedgePositionStatus',
];
